import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';
import { Input, Table, Drawer, Button, message, Divider, Popconfirm } from 'antd';
import ErrorWrapper from '../../../lib/error_wrapper';
import TransactionActionsAddEdit from './transaction_actions_addedit';
import { NetworkDelaySearch, showErrorInNotification, formatMoney } from '../../../lib/util';
import { COLORS } from '../../theme';



const queryString = require('query-string');

const action_cols=({onEditPressed,onDeletePresssed})=>[
  {
    title:"Name",
    dataIndex:'action_name'
  },
  {
    title:"Action",
    width:120,
    dataIndex:'id',
    render:(id,data)=><div style={{
      display:'flex',
      flexDirection:'row',
      alignItems:'center'
    }}><Button type='link' onClick={()=>{
      typeof onEditPressed==='function'&&onEditPressed(id,data)
    }}>Edit</Button>
    <Divider type='vertical'/>
    <Popconfirm arrowPointAtCenter placement='topLeft' title="Are you sure you want to delete this action?" onConfirm={()=>{
      typeof onDeletePresssed==='function'&&onDeletePresssed(id)
    }}>
      <Button type='link' style={{
        color:COLORS.danger_primary
      }} >Delete</Button>

    </Popconfirm>
    </div>
  }
]
class TransactionActionsList extends Component {
  constructor(props) {
    super(props)

    this.datatype_id = props.match.params.datatype_id;
    this.state = {
      filter_query: {
        per_page: 100,
        page: 1
      },
      edit_data: {},
      edit_id: null,
      add_edit_status: null
    };

    this.list_actions = RESTExecutor.list().forId(this.datatype_id).config({
      label: 'transaction_actions'
    }).connect(props.domains.datatype);

    this.delete_action=RESTExecutor.delete().config({
      label: 'transaction_actions_detail',
      params:{

      }
    }).callbacks((success)=>{
      message.success("Action deleted");
      this.list_actions.execute()
    },(error)=>{
      showErrorInNotification(error);
    }).connect(props.domains.datatype);

    this.delay_search=new NetworkDelaySearch()

  }

  stateUpdater = ({
    stateKey,
    valueKey,
    value,
    appendObj = {},
    callback
  }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }
  render() {
    let list_actions_resp = this.list_actions.response();
    let delete_action_resp=this.delete_action.response()
    let rowsData = (list_actions_resp.result && list_actions_resp.result.rows) || [];
    let rowsMeta = list_actions_resp.meta || {};
    const { filter_query } = this.state;

    return (
      <div>
        <BasicHeader title="Transaction Actions"
          right={[
            <TransparentButton
              label="Add New"
              hint="Add New Transaction Actionss"
              onClick={() => {
                this.setState({
                  add_edit_status: 'add',
                })
              }}

            />,
          ]}

        />
        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 12
          }}>
            <Input.Search
              autoFocus
              allowClear
              placeholder="Search For"
              style={{
              }}
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        // pathname:"users",
                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                      })
                    })
                  }
                })
              }} />

          </div></div>

        <ErrorWrapper error={list_actions_resp} onReload={() => {
          this.datatype_id = this.props.match.params.datatype_id;
          this.list_actions.forId(this.datatype_id).execute();
        }}>
          <div className='default-card' style={{
            padding: 0
          }}>
            <Table
                        className='main-table'
                        loading={list_actions_resp.fetching||delete_action_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            simple: false,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    // pathname:"users",
                                    search:queryString.stringify({...this.state.filter_query,per_page:size,page:current})
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            pageSize: (rowsMeta && rowsMeta.requested_count),
                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }} 
                        rowKey={(record) => record.id} columns={action_cols({
                            onEditPressed: (id, data) => {
                                this.setState({
                                    add_edit_status: 'edit',
                                    edit_id: data.id,
                                    edit_data: JSON.parse(JSON.stringify(data))
                                })
                            },
                            onDeletePresssed:(id)=>{
                              this.delete_action.config({
                                params:{
                                  datatype_id:this.datatype_id,
                                  action_id:id
                                }
                              }).execute()
                            }

                        })} dataSource={rowsData} />
          </div></ErrorWrapper>

          <Drawer
                    title="Transaction Action Add"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null
                        });
                        this.list_actions.execute();
                    }}
                    visible={this.state.add_edit_status === 'add'}
                >
                    <TransactionActionsAddEdit
                                        datatype_id={this.datatype_id}
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            });
                            this.list_actions.execute()
                        }}
                        onRefreshClose={()=>{
                            this.list_actions.execute();
                            this.setState({
                                add_edit_status:null
                            })
                        }}

                    />
                </Drawer>

                <Drawer
                    title="Transaction Action Edit"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null
                        });
                        this.list_actions.execute();
                    }}
                    visible={this.state.add_edit_status === 'edit'}
                >
                    <TransactionActionsAddEdit
                    datatype_id={this.datatype_id}
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            });
                            this.list_actions.execute()
                        }}
                        onRefreshClose={()=>{
                            this.list_actions.execute();
                            this.setState({
                                add_edit_status:null
                            })
                        }}
                        edit_id={this.state.edit_id}
                        edit_data={this.state.edit_data}

                    />
                </Drawer>


      </div>
    );
  }


  componentDidMount() {
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.list_actions.config({
        params: {
          ...this.state.filter_query
        }
      }).execute()
    })
  }

  componentWillReceiveProps(nextProps) {
    var olddatatype_id = this.props.match.params.datatype_id;
    var newdatatype_id = nextProps.match.params.datatype_id;


    if (olddatatype_id !== newdatatype_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.datatype_id = newdatatype_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed
        }
      }, () => {
        this.list_actions.forId(this.datatype_id).config({
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })

    }
  }


}

export default withDomains(TransactionActionsList, "datatype");
